import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { AuthContext } from '../../../component/context/AuthContext';
import axios from 'axios';
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import * as CONST from "../../../component/config/Constant";

function ViewQuiz({ closeQuizModal, editEmpId, firstName, lastName }) {

  const [authUserData] = useContext(AuthContext);
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [quizList, setQuizList] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [quizDetails, setQuizDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5; 

  let token = authUserData && authUserData[0] ? authUserData[0].token : '';

  useEffect(() => {
    fetchEmployeeQuizzes();
  }, []);

  const fetchEmployeeQuizzes = async () => {
    setLoading(true);
    try {
      const resp = await axios.get(
        CONST.ALL_QUIZ_LIST.replace(':user_id', editEmpId),
        {
          headers: { Authorization: `Basic ${token}` }
        }
      );

      if (resp.data.status === "success") {
        setQuizList(resp.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch quizzes");
    }
    setLoading(false);
  };

  const fetchQuizDetails = async (quizId) => {
    setLoading(true);
    try {
      const resp = await axios.get(
        CONST.QUIZ_HISTORY.replace(':set_id', quizId).replace(':user_id', editEmpId),
        {
          headers: { Authorization: `Basic ${token}` }
        }
      );

      if (resp.data.status === "success") {
        setQuizDetails(resp.data.data);
        setSelectedQuiz(quizId);
        setCurrentPage(1); // reset page
}
    } catch (err) {
      toast.error("Failed to fetch quiz details");
    }
    setLoading(false);
  };
    const totalQuestions = quizDetails.length;
    const totalScore = quizDetails.filter(q => q.is_correct).length;
    const totalPages = Math.ceil(quizDetails.length / questionsPerPage);

const paginatedDetails = quizDetails.slice(
  (currentPage - 1) * questionsPerPage,
  currentPage * questionsPerPage
);

  return (
    <>
      <Loading loading={loading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />

      <Modal
        size="xl"
        show={show}
        onHide={() => closeQuizModal()}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Quiz History - {firstName} {lastName}</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {!selectedQuiz && (
            <>
              <h5>Assigned and Completed Quizzes</h5>
              <hr />

              {quizList.length === 0 && <p>No Quiz Assigned</p>}

              <div className="list-group">
               {quizList.map((quiz) => (
                    <button
                        key={quiz.set_id || quiz.id}
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                        onClick={() => fetchQuizDetails(quiz.set_id || quiz.id)}
                    >
                        <div>
                            <strong>{quiz.title}</strong>
                            <div className="small text-muted">
                                Score: {quiz.score}/{quiz.total_questions}
                            </div>
                        </div>

                        {/* ✅ STATUS BADGE */}
                        <span
                        className={`badge ${
                            quiz.status === "completed"
                            ? "bg-success"
                            : quiz.status === "in_progress"
                            ? "bg-primary"
                            : "bg-warning"
                        }`}
                        >
                        {quiz.status === "completed"
                            ? "Completed"
                            : quiz.status === "in_progress"
                            ? "In Progress"
                            : "Assigned"}
                        </span>
                </button>
                ))}
              </div>
            </>
          )}

          {selectedQuiz && (
            <>
                <button
                className="btn btn-primary mb-3"
                onClick={() => setSelectedQuiz(null)}
                >
                Back to Quiz List
                </button>
                <div className="d-flex justify-content-between align-items-center">
                    <h5>Quiz Details</h5>

                    <span
                        className="badge bg-primary"
                        style={{ fontSize: "14px", padding: "8px 12px" }}
                    >
                        Score: {totalScore} / {totalQuestions}
                    </span>
                </div>
                <hr />

                {paginatedDetails.map((q, index) => {
                const isCorrect = q.is_correct;

                return (
                  <div
                    key={index}
                    className="card mb-3"
                    style={{
                      border: isCorrect
                        ? "2px solid #28a745"
                        : "2px solid #dc3545",
                      backgroundColor: isCorrect ? "#eaf7ee" : "#fdeaea",
                    }}
                  >
                    <div className="card-body">
                      <h6>
                        Q{(currentPage - 1) * questionsPerPage + index + 1}: {q.question_text}
                      </h6>
                      <hr />

                      {/* OPTIONS LIST */}
                      {(q.options || []).map((opt) => (
                        <div key={opt.id} style={{ marginBottom: "5px" }}>
                          {/* Ensure we use correct property names from backend */}
                          {opt.option_text}
                          
                        </div>
                      ))}

                      <hr />

                      {/* USER ANSWER */}
                      <div>
                        <strong>Given Answer: </strong>
                        {q.your_answer ? (
                          <span
                            style={{
                              color: isCorrect ? "#28a745" : "#dc3545",
                              fontWeight: "600",
                            }}
                          >
                            {q.your_answer.option_text}
                          </span>
                        ) : (
                          <span className="text-muted">Not Answered</span>
                        )}
                      </div>

                      {/* CORRECT ANSWER */}
                      <div>
                        <strong>Correct Answer: </strong>
                        <span style={{ color: "#28a745", fontWeight: "600" }}>
                          {q.correct_answer?.option_text}
                        </span>
                      </div>
                    </div>
                  </div>
                );
                })}
                {quizDetails.length > 0 && totalPages > 1 && (
  <div className="card-footer d-flex justify-content-between align-items-center mt-3">
    <span className="text-muted small">
      Showing page {currentPage} of {totalPages}
    </span>

    <nav className="ms-auto">
      <ul className="pagination pagination-sm mb-0">

        {/* Previous */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            {"<<"}
          </button>
        </li>

        {/* Page Numbers */}
        {[...Array(totalPages)].map((_, i) => (
          <li
            key={i}
            className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          </li>
        ))}

        {/* Next */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            {">>"}
          </button>
        </li>

      </ul>
    </nav>
  </div>
)}
        </>
    )}
        </Modal.Body>
        </Modal>
    </>
    );
}

export default ViewQuiz;